import React from 'react'
import PropTypes from 'prop-types'
import ReactHelmet from 'react-helmet'

const Helmet = ({ helmet }) => <ReactHelmet {...helmet} />

export default Helmet

Helmet.prototype = {
  helmet: PropTypes.object
}
